/**
 * @generated SignedSource<<3a1b8ce73cfba3bfd3345dbdf19729d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addQuoteRulePanel_QuoteRulesListQuery$variables = Record<PropertyKey, never>;
export type addQuoteRulePanel_QuoteRulesListQuery$data = {
  readonly quoteRulesList: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
    readonly quoteRuleID: number;
  }>;
};
export type addQuoteRulePanel_QuoteRulesListQuery = {
  response: addQuoteRulePanel_QuoteRulesListQuery$data;
  variables: addQuoteRulePanel_QuoteRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QuoteRule",
    "kind": "LinkedField",
    "name": "quoteRulesList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quoteRuleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addQuoteRulePanel_QuoteRulesListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addQuoteRulePanel_QuoteRulesListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e09552937ec484f83287d5a5bb7854c2",
    "id": null,
    "metadata": {},
    "name": "addQuoteRulePanel_QuoteRulesListQuery",
    "operationKind": "query",
    "text": "query addQuoteRulePanel_QuoteRulesListQuery {\n  quoteRulesList {\n    id\n    quoteRuleID\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f1e1cbae9d89b0f22b748d5151d12b1";

export default node;
